const connections = {
    urlDev: 'https://hdltechnology.com.mx/inventario/api/index.php',
    urlProd: 'https://hdltechnology.com.mx/sistema/api_inventario/index.php',
};

const icosIndicators = {
    //  Semaforo de productos



    exclamationRed: './assets/images/indicators/alert.png',
    arrowRed: './assets/images/indicators/arrow_red.png',
    arrowAmbar: './assets/images/indicators/arrow_ambar.png',
    arrowGreen: './assets/images/indicators/arrow_green.png',
    medal: './assets/images/indicators/medal.png',
    cancel: './assets/images/indicators/cancel.png',
    // Ordnes de compra
    orderList: './assets/images/indicators/orderList.png',
    orderProcess: './assets/images/indicators/orderProcess.png',
    orderAproved: './assets/images/indicators/orderAproved.png',

    orderCost: './assets/images/indicators/orderCost.png',
    orderSuccess: './assets/images/indicators/orderSuccess.png',
    orderEdit: './assets/images/indicators/orderEdit.png',
    orderNew: './assets/images/indicators/orderNew.png',
    orderPending: './assets/images/indicators/orderPending.png',
}

const images = {
    logo: './assets/images/logo.png',
};

const evidences = {
    urlDev: 'https://hdltechnology.com.mx/inventario/api/evidences/',
    urlProd: 'https://hdltechnology.com.mx/sistema/api_inventario/evidences',
};


export { connections, icosIndicators, images,evidences };